module.exports = __webpack_public_path__ + "img/necklace.24032836.png";